import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class DropDownButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: this.props.open
        };

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleClickOutsideMenu = this.handleClickOutsideMenu.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutsideMenu, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutsideMenu, true);
    }

    handleButtonClick() {
        if (this.props.disabled) {
            return;
        }
        this.setState(prevState => ({ open: !prevState.open }));
    }

    handleClickOutsideMenu(event) {
        const { dropDownButton, dropDownMenu } = this;

        if (dropDownMenu && !dropDownMenu.contains(event.target) && !dropDownButton.contains(event.target)) {
            this.setState({ open: false });
        }
    }

    renderOpenButton() {
        return (
            <div
                ref={(c) => { this.dropDownMenu = c; }}
                className="dijits_form_dropDownButton_menu dropShadowDark"
                style={{ padding: 0 }}
            >

                <div className="leader leaderRight" />

                <div style={{ width: 'auto' }}>
                    {this.props.children || null}
                </div>

            </div>
        );
    }

    render() {
        return (
            <div
                ref={(c) => { this.dropDownButton = c; }}
                id={this.props.id}
                className={`dijits_form_dropDownButton right ${this.props.className}`}
            >

                <div
                    role="button"
                    tabIndex={0}
                    className={classNames('button', 'small', { disabled: this.props.disabled })}
                    onClick={this.handleButtonClick}
                >

                    <div className="inline nomargin">
                        {this.props.label && <span className="dijitInline">{this.props.label}</span>}
                        &nbsp;
                        <span className="dijitInline dropDownImageNode" />
                    </div>
                </div>

                {this.state.open && this.renderOpenButton()}

            </div>
        );
    }
}

DropDownButton.propTypes = {
    children: PropTypes.element.isRequired,
    label: PropTypes.string,
    open: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    className: PropTypes.string
};

DropDownButton.defaultProps = {
    label: '',
    open: false,
    disabled: false,
    id: '',
    className: ''
};

export default DropDownButton;



// WEBPACK FOOTER //
// ./source/components/form/DropDownButton.jsx